<template lang="pug">
.content
  .row
    .col-md-12
      div.box_header
        label.title Thêm lớp học
        label.title-pc {{lstPC.name}}
        .clearfix
      div.box-content
        .box-pc-step
          .item-pc-content
            .form-group(v-bind:class="[isSubmitFinish && (key_name.length === 0 || key_exists) ? 'error' : '']")
              label.control-label Tên lớp học *
              input.form-control( name="key_name" maxlength = 125 placeholder="Nhập" autofocus v-model.trim="key_name")
              span.required(v-if="isSubmitFinish && key_name.length === 0") Vui lòng nhập tên lớp học
              span.required(v-if="isSubmitFinish && key_exists") Tên lớp học đã tồn tại
            .form-group(v-bind:class="[isSubmitFinish && (key_grade.length === 0 || key_grade === 0) ? 'error' : '']")
              label.control-label Khối lớp *
              select.form-control(name="key_grade" v-model.trim="key_grade")
                option(disabled value='0' :selected="key_grade === 0") Chọn khối lớp
                option(v-for='o in grades' v-bind:value='o.id' :selected="key_grade === o.id") {{o.name}}
              span.required Vui lòng chọn khối lớp
            .form-group(v-bind:class="[isSubmitFinish && lstIcons.length === 0 ? 'error' : '']")
              .box-icon
                label.control-label
                  strong Ảnh đại diện lớp học: 
                    span (Kích thước đề nghị: 300x300 px)
                #list_icon
                  .box-button
                    .item-button
                      input(id="icon" name="icon" type="file" accept="image/*" @change="onIconChange")
                      span Tải ảnh lên
                    .item-button
                      span(@click="openLibrary") Chọn từ thư viện
                  .box-item-icon
                    .box-item(v-if="icon" v-for="(icon, index) in lstIcons")
                      span.material-icons.remove(@click='deleteIcon(index)') cancel
                      img.img-responsive(:src="icon.src")
                    span.required Vui lòng upload ảnh đại diện
                    .clearfix
                  .clearfix
            .form-group(v-bind:class="[isSubmitFinish && lstIcons.length === 0 ? 'error' : '']")
              .box-item-private
                .link-join Link tham gia lớp học
                .box-function
                  input(:value="seoUrl" :id="'classes_' + item.id" readonly="true")
                  a.copy(@click.stop.prevent="doCopy('classes_' + item.id)")
                    img(src="../../assets/images/pc/ic_copy.svg")
                  ShareNetwork.share(network="facebook" :url="seoUrl" :title="key_name" :description="key_description")
                    img(src="../../assets/images/pc/ic_share.svg")
                  //- a.share(@click="doShare")
                    img(src="../../assets/images/pc/ic_share.svg")
                p
                  input(type="radio" :checked="key_private==0" id="private1" name="private" v-model="key_private" value="0")
                  label(for='private1') Tất cả mọi thành viên đều thấy và yêu cầu tham gia
                p
                  input(type="radio" :checked="key_private==1" id="private2" name="private" v-model="key_private"  value="1")
                  label(for='private2') Chỉ tôi được thêm thành viên vào lớp này
          .item-pc-bottom
            .form-group
              button.active(@click="submitSave()") Lưu thay đổi
              a.button(@click="backClasses") Huỷ yêu cầu
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import S3FileUpload from '../S3FileUpload/S3FileUpload.js'
import MdNotification from '@/core/components/mdNotification'
export default {
  components: {
    MdNotification,
    S3FileUpload
  },
  data() {
    return {
      message: this.$t('home.comming_soon'),
      lstPC: [],
      key_id: 0,
      key_name: '',
      key_description: '',
      grades: [],
      key_private: 0,
      key_grade: 0,
      lstIcons: [],
      lstIconsOld: [],
      seoUrl: '',
      icons: [],
      item: [],
      isSubmitFinish: false,
      key_exists: false,
      loader: null
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        container: null,
        canCancel: true,
        onCancel: this.onCancel
      })
    },
    url(pcName, clName, clID) {
      let url = window.location.origin + '/' + this.$router.resolve({name: 'join_classes'}).href + 'join-classes/'
      let seoUrl = url + this.$mycontroller.doSanitizeTitle(pcName) + '/' + this.$mycontroller.doSanitizeTitle(clName) + '-' + clID + '/yeucauthamgia'
      return seoUrl
    },
    doShare() {
      this.showNotification(this.message, 'warning', 'top', 'right', 7000)
    },
    doCopy(pageID) {
      let textID = document.querySelector('#' + pageID)
      textID.select()
      try {
        var successful = document.execCommand('copy')
        if (successful) this.showNotification('Copy thành công', 'success', 'top', 'right', 2000)
        else this.showNotification('Không thể copy', 'warning', 'top', 'right', 2000)
      } catch (err) {
        this.showNotification('Không thể copy', 'warning', 'top', 'right', 2000)
      }
    },
    openLibrary() {
      this.showNotification(this.message, 'warning', 'top', 'right', 2000)
    },
    deleteIcon: function (index) {
      let img = this.lstIcons[index]
      this.lstIcons.splice(index, 1)
      if (img.file === '') {
        this.lstIconsOld.push(img)
      }
    },
    onIconChange(e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.lstIcons = []
      for (let i = 0; i < files.length; i++) {
        let obj = {'name': files[i].name, 'file': files[i], 'src': URL.createObjectURL(files[i])}
        this.lstIcons.push(obj)
      }
    },
    backClasses() {
      this.$router.push({name: 'classes', query: {id: this.lstPC.id}})
    },
    async checkClassesName() {
      await this.$apollo.query({
        query: gql(graphql.GET_CLASSES_OF_PC),
        fetchPolicy: 'no-cache',
        variables: {
          where: {
            name: {_ilike: this.key_name},
            id: {_neq: this.key_id}
          }
        }
      }).then(response => {
        this.key_exists = response.data.classes.length > 0
      })
    },
    submitSave() {
      this.isSubmitFinish = true
      if (this.isSubmitFinish && this.key_name.length > 0 && this.key_grade > 0 && this.lstIcons.length > 0 && this.$store.getters.user !== '') {
        this.save()
      }
    },
    async save() {
      await this.checkClassesName()
      if (!this.key_exists) {
        this.show()
        var changes = {
          name: this.key_name,
          grade_id: this.key_grade,
          private: this.key_private > 0,
          type_approval: this.key_private > 0 ? 1 : this.item.type_approval,
          updated_by: this.$store.getters.user
        }
        this.$apollo.mutate({
          mutation: gql(graphql.UPDATE_CLASSES2),
          variables: {
            where: {
              id: {_eq: this.key_id},
              pc_id: {_eq: this.lstPC.id}
            },
            changes: changes
          },
          update: (store, { data: { update_classes } }) => {
            if (update_classes.affected_rows) {
              let returning = update_classes.returning[0]
              this.updateUploadImg(returning.id)
            }
          }
        }).catch((error) => {
          this.loader.hide()
          this.showNotification(error, 'warning', 'top', 'right', 2000)
        })
      }
    },
    async updateUploadImg($id) {
      let directory = 'images/classes'
      let config = S3FileUpload.computed.config(directory)
      let S3Client = new S3FileUpload.computed.S3Client(config)
      if (this.lstIcons.length > 0) {
        for (let index = 0; index < this.lstIcons.length; index++) {
          let icon = this.lstIcons[index]
          let file = icon.file
          let src = icon.src
          if (file !== '') {
            let fileName = icon.name.split('.')[0].replace(/ /g, '').toLowerCase().trim()
            let random = Math.random().toString().slice(2)
            let fieldName = `${random}_${fileName}`
            await S3Client.uploadFile(file, fieldName).then((data) => {
              this.icons.push(data.location)
            })
          } else {
            this.icons.push(src)
          }
        }
        this.$apollo.mutate({
          mutation: gql(graphql.UPDATE_CLASSES_IMG),
          variables: {
            id: $id,
            pc_id: this.lstPC.id,
            thumbnail: this.icons.length > 1 ? '{' + this.icons.join() + '}' : this.icons[0]
          },
          update: (store, { data: { update_classes } }) => {
            if (update_classes.affected_rows) {
              this.loader.hide()
              this.$router.push({name: 'classes', params: {reload: 1}, query: {id: this.lstPC.id}})
            }
          }
        })
      }
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    }
  },
  beforeDestroy() {
  },
  async created () {
    var classID = this.$route.params.class_id
    if (classID === undefined) classID = this.$mycontroller.openStorage('class_id')
    let result = await this.$apollo.query({
      query: gql(graphql.GET_CLASSES_TO_PC),
      fetchPolicy: 'no-cache',
      variables: {
        id: classID,
        pc_id: this.lstPC.id
      }})
    if (result.data.classes != null) {
      this.item = result.data.classes[0]
      this.key_id = this.item.id
      this.key_name = this.item.name
      this.key_description = this.item.description
      this.key_grade = this.item.grade_id
      this.key_private = this.item.private ? 1 : 0
      this.seoUrl = this.url(this.item.private_community.name, this.item.name, this.item.id)
      let url = this.item.thumbnail
      if (url !== null && url !== '') {
        let split = url.split('/')
        let fileName = split[split.length - 1]
        let obj = {'name': fileName, 'file': '', 'src': url}
        this.lstIcons.push(obj)
      }
    }
  },
  apollo: {
    grades: {
      query: gql(graphql.GET_GRADES),
      update: data => {
        for (var i = 0; i < data.grades.length; i++) {
          data.grades[i].selected = false
        }
        return data.grades
      }
    },
    lstPC: {
      query: gql(graphql.GET_PC_OF_USER),
      variables() {
        return {
          where: {
            user_id: {_eq: this.$store.getters.user},
            id: {_eq: this.$route.query.id}
          }
        }
      },
      update: data => {
        return data.private_community[0]
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.box_header{
  .title{text-align: left; font-size: 20px; font-weight: bold; letter-spacing: 0px;color: #5F6468;}
  .title-pc{color: #3C4858 !important; font-size: 16px;display: block; margin-top: 10px;}
}
.box-content{margin-top: 15px;width: 100%;
    .box-pc-step{margin: 0 auto; 
      .item-pc-title{text-align: left; font-size: 17px; font-weight: bold; font-family: Helvetica;letter-spacing: 0px;color: #333;}
      .item-pc-content{
        .form-group{position: relative; margin-top: 10px; padding-bottom: 0;
          input, select{background: #fff; border-radius: 10px;}
          &.error{
            input, select{border: 1px solid #f00;color: #f00;}
            span.required{display: block; color: #f00; text-align: left;}
          }
          label{font-size: 13px;color: #333;margin-bottom: 10px; font-weight: bold; display: block;}
          span.characters{position: absolute; right: 0; font-weight: normal;font-size: 12px;
            &.italic{font-style: italic;}
          }
          span.required{display: none;}
          .box-icon{
            label{
              strong{
                span{color:#969FAD !important;font-weight: normal !important; }
              }
            }
            .box-item{float:left;width: 122px;height: 122px; margin-left:15px;margin-bottom:10px; position: relative; 
              input{cursor: pointer;}
              img{max-width: 100%; height: auto; max-height: 100%; margin: 0 auto;}
              span{position: absolute; right: 5px; top:5px;cursor: pointer;
                &.remove{color: #f00;}
              }
            }
          }
          #list_icon{margin-top: 10px;
            .box-button{width: 122px; float: left;
              .item-button{height: 30px; background: #FAFAFA 0% 0% no-repeat padding-box;box-shadow: 0px 1px 1px #00000029;border: 0.5px solid #E0E0E0;border-radius: 5px; text-align: center; display: block; width: 100%; margin-bottom: 10px; position: relative;
                input[type='file']{cursor: pointer;}
                span{color: #343A40; font-size: 13px; display: block;line-height: 30px; cursor: pointer;}
              }
            }
            .box-item-icon{margin:0; width: calc(100% - 140px); float: left;
              span.required{margin-left: 15px;}
            }
          }
          .box-item-private{background: #fff; padding: 15px; border-radius: 10px;
            .link-join {font-size: 16px; font-weight: bold; color:#000;}
            .box-function{margin: 10px 0;
              input{display: inline-block; background: #E0E0E0 0% 0% no-repeat padding-box; height: 30px; width: calc(100% - 70px); border: 0 none;letter-spacing: 0px;color: #9B9B9B; font-size: 10px; padding: 0 10px; font-size: 13px;}
              a{display: inline-block; width: 16px; margin-left: 5px; color: #9B9B9B; cursor: pointer;
                span{font-size: 18px;}
              }
            }
            p{margin: 0;
              &:last-child{
                label{margin: 0;}
              }
              label{font-weight: normal;}
              input[type="radio"], input[type="radio"]:checked,input [type="radio"]:not(:checked) { position: absolute; left: -9999px;}
              input[type="radio"]:checked + label,
              input[type="radio"]:not(:checked) + label{position: relative;padding-left: 28px;cursor: pointer;line-height: 20px;display: inline-block;color: #666;}
              input[type="radio"]:checked + label:before,
              input[type="radio"]:not(:checked) + label:before {content: ''; position: absolute;left: 0;top: 0;width: 18px;height: 18px;border: 1px solid #23180A;border-radius: 100%;background: #fff;}
              input[type="radio"]:checked + label:after,
              input[type="radio"]:not(:checked) + label:after {content: '';width: 10px; height: 10px; background: #9F6A28; position: absolute;top: 4px; left: 4px;border-radius: 100%; -webkit-transition: all 0.2s ease;transition: all 0.2s ease;}
              input[type="radio"]:not(:checked) + label:after {opacity: 0; -webkit-transform: scale(0);transform: scale(0);}
              input[type="radio"]:checked + label:after {opacity: 1; -webkit-transform: scale(1);transform: scale(1);}
            }
          }
        }
      }
      .item-pc-bottom{text-align: left;
        button{margin: 0; padding: 10px 25px; background: #fff 0% 0% no-repeat padding-box; border-radius: 5px;border: 1px solid #FFD311; font-size: 14px; display: inline-block; color: #23180A;
          &.active{background: #FFD311 0% 0% no-repeat padding-box;margin-right: 15px;}
        }
        a.button{text-align: center; cursor: pointer; margin: 0; padding: 10px 25px;  background: transparent 0% 0% no-repeat padding-box;border: 0 none;border-radius: 5px;color: #23180A; font-size: 14px; display: inline-block;}
      }
    }
}
@media (max-width: 1366px){
  
}
@media (max-width: 1024px){
  
}
@media (max-width: 991px){
  
}
@media (max-width: 767px){
  .box-content{
    .box-pc-step{ width: 100%;
      .item-pc-title{display: none;}
      .item-pc-img{margin: 20px 0;}
      .item-pc-bottom{
        span{display: initial;}
      }
    }
  }
}
@media (max-width: 560px){
  .box_step{text-align: center; margin:  25px auto;
  }
  .box-content{
    .width-50{width: 100%;}
    .box-pc-create{
      .item-pc-bottom{
        button{width: 100%;margin-bottom: 10px;}
        a.button{width: 100%; }
      }
    }
    .box-pc-step{
      .item-pc-bottom{
        button{width: 100%;margin-bottom: 10px;}
        a.button{width: 100%; }
      }
    } 
  }
}
</style>



// WEBPACK FOOTER //
// edit.vue?2788bfa3